'use strict'

module.exports =
function copy (obj) {
  var o = {}
  Object.keys(obj).forEach(function (i) {
    o[i] = obj[i]
  })
  return o
}



//////////////////
// WEBPACK FOOTER
// ./~/youtube-node/~/request/lib/copy.js
// module id = 432
// module chunks = 0